module.exports = __webpack_public_path__ + "img/天府新区和韵幼儿园.5f1cefda.jpg";